import { RequestsFormStore } from "@/services/stores/types";

export const selectRequestFormStore = ({
  documentsInitialized,
  setDocumentsInitialized,
  isAcknowledged,
  setIsAcknowledged,
  requestFormData,
  setRequestFormData,
  setRequestFormDataDocs,
  removeRequestFormData,
  removeRequestFormDataDocs,
  resetRequestFormDataDocs,
  resetRequestFormDataPersonnels,
  resetRequestFormDataNumbers,
  resetRequestFormData,
}: RequestsFormStore) => ({
  isAcknowledged,
  setIsAcknowledged,
  documentsInitialized,
  setDocumentsInitialized,
  requestFormData,
  setRequestFormData,
  setRequestFormDataDocs,
  removeRequestFormData,
  removeRequestFormDataDocs,
  resetRequestFormDataDocs,
  resetRequestFormDataPersonnels,
  resetRequestFormDataNumbers,
  resetRequestFormData,
});

export const selectRequestFormData = ({
  requestFormData,
}: RequestsFormStore) => ({ requestFormData });
